import clsx from 'clsx'

interface DashProps {
  active: boolean
}

export function Dash({ active }: DashProps) {
  return (
    <div
      className={clsx(
        'h-[5px] rounded-full transition-colors pointer-events-none duration-300',
        active ? 'bg-mint' : 'bg-white',
      )}
    />
  )
}
